export default (value: any) => {
    switch (String(value)) {
        case "1": return "LICEALE INDIRIZZO SCIENZE APPLICATE";
        case "2": return "ECONOMICO INDIRIZZO AMMINISTRAZIONE,FINANZA E MARKETING";
        case "3": return "ECONOMICO INDIRIZZO TURISMO";
        case "4": return "TECNOLOGICO INDIRIZZO INFORMATICA";
        case "5": return "TECNOLOGICO INDIRIZZO ELETTRONICA";
        case "6": return "TECNOLOGICO INDIRIZZO MECCANICA";
    }
}